/**
 * This will be wrapper component for all the routes in the application. it will receive Router component as child and will render it, it will also hold all other components which are required to be rendered on all the routes. like Toast component, Loader component etc.
 */

import React from 'react';
import Toast from 'src/components/Toast';
import { unstable_usePrompt } from 'react-router-dom';
import { store } from 'src/redux';
import AppUpdateBlocker from 'src/components/AppUpdateBlocker';

/**
 * TODO - remove this as route wrapper. Let it be a common wrapper in App.tsx
 */
const RouteWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  /**
   * It only blocks navigatation with in the SPA. it does not take care of hard-reloads and cross origin navigations.
   */
  unstable_usePrompt({
    message: 'You have some unsaved changes, do you want to proceed without saving them?',
    //@ts-ignore
    when: ({ currentLocation, nextLocation }: any) => {
      const {
        draftData: { localChangesVersion = 0, error = '' },
      } = store.getState() || {};
      const val = localChangesVersion > 0 && !error && currentLocation.pathname !== nextLocation.pathname;
      return val;
    },
  });

  return (
    <>
      <AppUpdateBlocker />
      <Toast />
      {children}
    </>
  );
};

export default RouteWrapper;
